import { useEffect } from 'react';
import { getUserManager } from '@components/Auth/manager';

export const useAuth0LogoutRedirect = () => {
  const tryLogout = async () => {
    const userManager = getUserManager();
    await userManager.signoutRedirect();
    localStorage.clear();
  };
  useEffect(() => {
    tryLogout();
  }, []);
};
